/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Error_DescriptionInputs */

const sv_page_error_description = /** @type {(inputs: Page_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det är ett internt fel på servern och vi jobbar på att åtgärda problemet. Webbplatsen kommer att vara igång inom kort`)
};

const en_page_error_description = /** @type {(inputs: Page_Error_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is an internal error on the server and we’re working to fix the problem. The site will be up and running shortly`)
};

/**
* | output |
* | --- |
* | "There is an internal error on the server and we’re working to fix the problem. The site will be up and running shortly" |
*
* @param {Page_Error_DescriptionInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_error_description = /** @type {((inputs?: Page_Error_DescriptionInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Error_DescriptionInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_error_description(inputs)
	return en_page_error_description(inputs)
});